import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import useSinglePartMutations from "./useSinglePartMutations";
import { ISingleCategoryPartResponse } from "../models/Part";

export default function useSinglePart(partId: string | undefined) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60; // 1 minute
  const enabled = Boolean(partId);

  const mutations = useSinglePartMutations(partId);

  const singlePart = useQuery({
    queryKey: ["parts", partId],
    queryFn: async () => {
      const offerView = await get<ISingleCategoryPartResponse>(`/part/${partId}/offers`);

      if (offerView?.data) {
        return offerView;
      }

      return get<ISingleCategoryPartResponse>(`/part/details/${partId}`);
    },
    staleTime,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    ...mutations,
    singlePart,
  };
}
